import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
const { Content } = Layout;

const ContractorClientsOverviewPage: FC<any> = ({
	userType,
	history,
	companyConfig,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/${userType}/contractor_clients/overview/${key}`);
		},
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = useMemo(() => {
		return [
			{
				key: 'all',
				name: 'All',
			},
			{
				key: 'locations',
				name: 'All Locations',
			},
		];
	}, []);

	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Route
					path={`/${userType}/contractor_clients/overview`}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/${userType}/contractor_clients/overview/all`,
							}}
						/>
					)}
				/>
				<Content>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<h4
							style={{
								color: 'rgba(255, 255, 255, 0.9)',
								marginRight: 8,
								marginBottom: 24,
							}}
						>
							Clients
						</h4>
						<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps)(ContractorClientsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
